<template>
    <c-modal
            v-model="model"
            confirmLabel="Clear Tab & Continue"
            centered
            :size="'lg'"
            hide-header
            title="Attention"
            :tag="false"
            :progressing="loading"
            @hide="hide"
            @submit="submit">
        <template>
            <div class="font-weight-bold h4 text-center">
                <p class="mb-0" v-if="orderTypeId !== 2">
                    <span v-if="tabNo">{{'Tab ' + tabNo + ' was created.'}}</span>
                    <span v-else>{{'New tab created.'}}</span>
                </p>
                <p class="mb-0" v-else>
                    {{'Tab ' + tabNo + ' - ' + order.tableNumber + ' was created.'}}
                </p>
            </div>

            <template v-if="orderTypeId === 2">
                <div class="text-center" v-if="hasCourse">
                    <p class="mb-0">
                        Food/Drink items are all confirmed and sent to kitchen.
                    </p>
                </div>
                <div class="text-center" v-else>
                    <p class="mb-0">
                        Food/Drink items are NOT confirmed.
                    </p>
                    <p class="mb-0">
                        Manually confirm items in the tab to send to kitchen.
                    </p>
                </div>
            </template>

            <template v-else>
                <template v-if="payType === 'card'">
                    <div class="text-center">
                        <p class="mb-0">
                            Food/Drink items are all confirmed and sent to kitchen.
                        </p>
                    </div>
                </template>
                <template v-else>
                    <div v-if="orderTypeId === 1">
                        <div v-if="autoConfirmPickup" class="text-center">
                            <p class="mb-0">
                                Food/Drink items are NOT confirmed.
                            </p>
                            <p class="mb-0">
                                Once tab is paid, items will automatically be confirmed and sent to kitchen.
                            </p>
                        </div>
                        <div v-else class="text-center">
                            <p class="mb-0">
                                Food/Drink items are NOT confirmed.
                            </p>
                            <p class="mb-0">
                                Once tab is paid, manually confirm items in the tab to send to kitchen.
                            </p>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="autoConfirmDelivery" class="text-center">
                            <p class="mb-0">
                                Food/Drink items are NOT confirmed.
                            </p>
                            <p class="mb-0">
                                Once tab is paid, items will automatically be confirmed and sent to kitchen.
                            </p>
                        </div>
                        <div v-else class="text-center">
                            <p class="mb-0">
                                Food/Drink items are NOT confirmed.
                            </p>
                            <p class="mb-0">
                                Once tab is paid, manually confirm items in the tab to send to kitchen.
                            </p>
                        </div>
                    </div>
                </template>
            </template>



            
            <div v-if="payBackCash!='' && payBackCash!='0.00' && payBackCash">
                <div class="m-4 text-center text-danger font-weight-bold" :style="{'font-size':'large'}">Change to Give Back to Customer: ${{payBackCash}}</div>
            </div>
        </template>
        

        <template #actions >
            <b-row v-if="!showPrintersMode" class=" ml-2 flex-grow-1 justify-content-center w-100">
                <b-col cols="4">
                    <b-btn variant="success" size="lg" style="font-size: 1.3em !important;height: 3rem !important;" block class="text-nowrap" :to="`/todayOrders/index?orderId=${orderId}`">
                        View Created Tab
                    </b-btn>
                </b-col>
                
                <b-col  v-if="printers.length > 0" cols="4">
                    <b-btn  variant="warning" size="lg" style="font-size: 1.3em !important;height: 3rem !important;" block class="text-nowrap" @click="showPrinters">
                        Print Customer Receipt
                    </b-btn>
                </b-col>
                <b-col v-else cols="0">
                    
                </b-col>
                <b-col cols="4" >
                    <b-btn variant="danger" size="lg" style="font-size: 1.3em !important;height: 3rem !important;" block class="text-nowrap cancel-btn-cmodal" @click="hide">
                        Close
                    </b-btn>
                </b-col>

            </b-row>
            
            <b-row v-else class="flex-grow-1 justify-content-center w-100">

            <b-col cols="4">
                    <b-btn variant="warning"  block class="text-nowrap" :disabled="loading" @click="printReceipt">
                        Print Receipt
                    </b-btn>
                </b-col>

                <b-col cols="4" >
                    <b-btn variant="dark" style="background-color:#78909C !important" block class="text-nowrap" @click="()=>{showPrintersMode = false}">
                        Cancel Print
                    </b-btn>
                </b-col>
            </b-row>
            <b-row v-if="orderTypeId !== 2 && payType === 'card'" class="flex-grow-1 justify-content-center w-100">
                <b-col cols="12">
                    <div v-if="!showEmail" class="mt-2 d-flex flex-column align-items-center">
                        <b-btn variant="link" size="md" @click="showEmail = true">Email the receipt</b-btn>
                    </div>
                    <div v-else class="mt-2 d-flex flex-column align-items-center">
                        <b-input-group :prepend="'Email address'" class="mb-2 mr-4 mt-4" style="max-width: 400px;">
                            <b-input class="myFeild" size="lg" :name="'Email address'" v-model="email" placeholder="Optional" v-validate="'required'"/>
                        </b-input-group>
                        <b-btn variant="warning" size="lg" class="text-nowrap mr-4 mt-3" :disabled="loading" @click="submit">
                            Submit Email
                        </b-btn>
                    </div>
                </b-col>
            </b-row>

        </template>
        
        <template v-if="showPrintersMode">
            <b-row class=" ml-2 px-4 " :style="{'overflow-y':'scroll !important'}">

                <b-form-group label=""  v-slot="{ ariaDescribedby }" class="m-4 flex-grow-1 justify-content-center">
                        <b-form-radio-group
                                v-model="selectedPrinter"
                                :options="printerList"
                                :aria-describedby="ariaDescribedby"
                                :style="{gap:'2rem', 'text-wrap': 'nowrap'}"
                                buttons
                                size="lg"
                                button-variant="outline-warning"
                        ></b-form-radio-group>
                </b-form-group>
            </b-row>
        </template>
        
    </c-modal>
</template>

<script>
    import CModal from "../../shared/Cmodal";
    export default {
        name: "attentionRemoveItems",
        components: {CModal},
        props: {
            order: {required: true, type: Object, default: {}},
            value: {required: true, type: Boolean, default: false},
            tabNo: {type: [Number, String, null], default: ''},
            orderTypeId: {required: true, default: '', type: [String, Number]},
            orderId: {default: '', type: [String, Number]},
            payType: {default: 'card', type: String},
            printers:{required: false,},
            orderItems: {
                default: [],
                required: true,
                type: Array
            },
            autoConfirmPickup: {
                type: Boolean,
                default: false
            },
            autoConfirmDelivery: {
                type: Boolean,
                default: false
            },
            payBackCash:{
                type:String,
                required:false,
                default:""
            }
        },
        data () {
            return {
                showEmail: false,
                email: null,
                loading: false,
                showPrintersMode:false,
                selectedPrinter:"",
                printerList:[]
            }
        },
        watch: {
            'printers': {
                handler: function () {
            
                    if(this.printers.length > 1){
                        this.printers.forEach(el => {
                            if(!el.IsLinked)
                                this.printerList.push(el.PrinterName)
                        });
                        this.selectedPrinter = this.printerList[0]
                    }
                }}
        },
        computed: {
            model: {
                get () {
                    return this.value
                },
                set (val) {
                    this.$emit('input', val)
                }
            },
            hasCourse () {
                return this.orderItems.find(item => item.CourseNo)
            }
        },
        methods: {
            showPrinters(){
                let numOfUnlinkedPrinter = this.printers.filter(el=>el.IsLinked != true).length

                if(this.printers.length === 1 || numOfUnlinkedPrinter === 1){
                    return this.printReceipt()
                }
                if(numOfUnlinkedPrinter > 1){
                    this.showPrintersMode = true
                }
            },
            printReceipt(){
                let numOfUnlinkedPrinter = this.printers.filter(el=>el.IsLinked != true).length
                if(this.printers.length === 1 || numOfUnlinkedPrinter === 1){
                    return this.$emit("printReceipt")
                }
                let tmp =[]
                this.printers.forEach(el => {
                        tmp.push(el.PrinterName)
                })
                
                
                return this.$emit("printReceipt",this.selectedPrinter)

            },
            hide () {
                this.reset()
                this.$emit("refresh")
            },
            submit () {
                this.showEmail = false
                if (this.email) {
                    let model = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        OrderId: this.orderId,
                        PhoneNumber: this.order.phoneNumber ? '+1' + this.order.phoneNumber.replace(/-/g, '') : '',
                        CustomerEmail: this.email
                    }
                    this.loading = true
                    this.$api.getRestaurant.SendEmailReceipt(model).then(res => {
                        this.loading = false
                        if (res.success) {
                            this.showEmail = false
                            this.reset()
                        } else {
                            this.$showError(res.message)
                        }
                    }).catch(err => {

                    })
                }
            },
            reset () {
                this.email = null
                this.showEmail = false
                this.showPrintersMode = false
            }
        }
    }
</script>

<style scoped>

</style>
